import './_resource.scss'
import { ReactComponent as ScreenIcon } from 'assets/icons/screen.svg'
import { ReactComponent as PresentationIcon } from 'assets/icons/presentation.svg'
import { ReactComponent as LayersIcon } from 'assets/icons/layers.svg'
import { ReactComponent as InboxIcon } from 'assets/icons/inbox.svg'
import { ReactComponent as VideosIcon } from 'assets/icons/videos.svg'
import { ReactComponent as MenuIcon } from 'assets/icons/menu.svg'
import { Link } from 'types'

export interface ResourceProps {
  icon: string
  linkList?: {
    title: string
    links: Link[]
  }
}

const ResourceIcons: { [key: string]: any } = {
  screen: ScreenIcon,
  presentation: PresentationIcon,
  layers: LayersIcon,
  inbox: InboxIcon,
  videos: VideosIcon,
  menu: MenuIcon,
}

export const Resource = ({ icon, linkList: links }: ResourceProps) => {
  const IconComponent = ResourceIcons[icon]

  return (
    <div className='resource'>
      <div className='resource__heading'>
        <div className='resource__heading__icon'>{IconComponent && <IconComponent />}</div>
        {links?.title && <p className='resource__heading__title'>{links.title}</p>}
      </div>
      {links?.links && (
        <ul className='resource__links'>
          {links.links.map((link, idx) => (
            <li key={idx}>
              <a target={link.target} href={link.url} className='resource__links__link'>
                <span>{link.text}</span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
